<!-- Enhanced Chat Container -->
<div class="containerChat793 chat" [class.containerChat793--embedded]="embedded">
  <!-- Chat Header when not owner. Embedded: hidden for the plain 1:1
       conversation (wireframe has no inner header) but kept as a slim
       back-bar when the owner flow drilled into a contact (selectedUser
       set) — the back arrow lives here. -->
  <div class="header793" id="OWNER_1" *ngIf="!messageDataPass.owner && (!embedded || selectedUser != undefined)">
    <!-- Close Button (embedded exits via tab switch instead) -->
    <div class="closeBtn793" *ngIf="!embedded" (click)="closemodel()">
      <svg width="16" height="16" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M18 6L6 18M6 6l12 12" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>

    <!-- Back Button -->
    <!-- <img src="assets/icon/back.png" (click)="backchat(messageDataPass)" *ngIf="selectedUser!=undefined"
      style="width:18px; cursor:pointer;"> -->

    <div style="cursor:pointer;"  (click)="backchat(messageDataPass)" *ngIf="selectedUser!=undefined">
      <ng-icon name="tablerArrowLeft" class="back"></ng-icon>
    </div>  

    <!-- Group/User Image -->
    <div class="grp-img793">
      <!-- Support Image -->
      <img class="i3" style="position: relative;" *ngIf="Support" src="assets/icon/Sumoface_final.png"
        onerror="this.src='assets/icon/Sumoface_final.png';" alt="">

      <!-- User Photo -->
      <img class="i3" style="position: relative;"
        *ngIf="userData?.photo&&!Support && selectedUser?.groupType!='SUPPORT'" src="{{getPhotoUrl(userData?.photo)}}">

      <!-- Group Logo -->
      <img class="i3" style="position: relative;"
        *ngIf="!userData?.photo&&!Support && selectedUser?.groupType!='SUPPORT'&&selectedUser!=undefined&&selectedUser?.groupLogo"
        src="{{getPhotoUrl(selectedUser?.groupLogo)}}">

      <!-- Initials for Group -->
      <div
        *ngIf="!userData?.photo&&!Support && selectedUser?.groupType!='SUPPORT'&&selectedUser!=undefined&&!selectedUser?.groupLogo">
        <div class="messageusername793 message-avatar" [style.background-color]="getColor(selectedUser?.groupName)">
          <div class="circletext793" [style.color]="getFullNameTextColor(selectedUser?.groupName)">{{
            getInitials(selectedUser?.groupName) }}</div>
        </div>
      </div>

      <!-- Initials for User -->
      <div *ngIf="!userData?.photo&& !Support && selectedUser?.groupType!='SUPPORT'&&selectedUser==undefined">
        <div class="messageusername793 message-avatar"
          [style.background-color]="getColorName(userData?.firstName,userData?.lastName)">
          <div class="circletext793" [style.color]="getTextColor(userData?.firstName,userData?.lastName)">{{
            getInitialName(userData?.firstName,userData?.lastName) }}</div>
        </div>
      </div>

      <!-- Support Icon -->
      <img class="i3" style="position: relative;" *ngIf="!Support && selectedUser?.groupType=='SUPPORT'"
        src="assets/icon/Sumoface_final.png" onerror="this.src='assets/icon/Sumoface_final.png';" alt="">

      <!-- Online Status Indicator -->
      <span *ngIf="userData?.online=='ONLINE' && selectedUser?.groupType!='SUPPORT'" class="logged-in793">●</span>
      <span *ngIf="userData?.online=='OFFLINE' && selectedUser?.groupType!='SUPPORT'" class="logged-out793">●</span>
    </div>

    <!-- Group/User Info -->
    <div class="grp-info793" *ngIf="!Support">
      <!-- User Name -->
      <div class="name-tooltip-wrapper" *ngIf="selectedUser==undefined" title="{{userData?.firstName}} {{userData?.lastName}}">
        <h3 class="grp-name793">
          {{userData?.firstName}} {{userData?.lastName}}
        </h3>
      </div>

      <div class="name-tooltip-wrapper" *ngIf="selectedUser!=undefined" title="{{selectedUser?.groupName}}">
        <h3 class="grp-name793">
          {{selectedUser?.groupName}}
        </h3>
      </div>

      <!-- Entity ID -->
      <p class="grp-entityid793" style="margin-left: 0; font-size: 11px; color: rgba(255,255,255,0.8); margin-bottom: 0;"
        *ngIf="selectedUser?.groupType!='SUPPORT' && selectedUser?.groupType!='USER' || messageDataPass.groupType!='USER' && messageDataPass.groupType!='SUPPORT'">
        {{messageDataPass?.entityId}}
      </p>
    </div>

    <!-- Support Info -->
    <div class="grp-info793" *ngIf="Support">
      <h3 class="grp-name793" title="Support"> Support </h3>
    </div>
  </div>

  <!-- Chat Header when owner (list view). Embedded: hidden — the Chat tab
       itself is the title. -->
  <div class="header793" id="OWNER_2" *ngIf="messageDataPass.owner && !embedded">
    <div class="closeBtn793" (click)="closemodel()">
      <svg width="16" height="16" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M18 6L6 18M6 6l12 12" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>

    <!-- Chat Title -->
    <div class="flex">
      <h4 style="margin: 0; font-size: 16px; font-weight: 500; color: #fff !important;"> Chat </h4>
    </div>
  </div>

  <!-- Chat Messages Area when not owner -->
  <div *ngIf="!messageDataPass.owner" id="NOTOWNER" class="chatbox793">
    <div #container class="messages793" infinite-scroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="100"
      [scrollWindow]="false" (scrolledUp)="onModalScrollDown()">

      <!-- Loading Skeleton — 3 bubble pairs in the floating bubble (its
           pre-refactor look); 2 in the embedded pane, whose visible height
           is smaller and overflowed with 3. `.chat-skel-v3` swaps the gray
           slab skin for wireframe ghost bubbles (embedded only). -->
      <app-common-skeleton *ngIf="loaderstartstop && selectedUser?.groupType!='SUPPORT'"
        [NameOftheScreen]="'messageConversation'" [countforView]="embedded ? 2 : 3"
        [class.chat-skel-v3]="embedded"></app-common-skeleton>

      <!-- No Data Message -->
      <div class="gs-empty" *ngIf="messageList.length==0 && !loaderstartstop">
        <span class="gs-empty-icon"><ng-icon name="tablerMessage"></ng-icon></span>
        <div class="gs-empty-title">{{ nodatafound || 'No messages' }}</div>
      </div>

      <!-- Messages -->
      <ng-container messagescroll *ngFor="let item of sortByMsg(messageList, 'sentDate')| messageunique">
        <!-- Regular Chat Message -->
        <div class="chat-message793" *ngIf="item.eventType=='CHAT' || item.eventType==null" [id]="item['messageId']"
          [ngClass]="{'right793': item['authorId'] === userId, 'left793': item['authorId'] !== userId}">

          <!-- Message Options Menu -->
          <div class="btn-group" style="height: 70px;" dropdown>
            <a id="button-animated" dropdownToggle *ngIf="item.enableDelete && item.authorId==userId">
              <ng-icon name="tablerDots" style="font-size: 12px; color: #928d93; margin-top: 10px;"
                aria-hidden="true"></ng-icon>
            </a>
            <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
              style="right: -5px; left: auto; margin-top: -29px;" aria-labelledby="button-animated">
              <ng-container>
                <li role="menuitem">
                  <a (click)="edit(item)">
                    <ng-icon name="tablerPencil" class="m-5"></ng-icon> Edit
                  </a>
                </li>
                <li role="menuitem">
                  <a (click)="delete(item)">
                    <ng-icon name="tablerTrash" class="m-5"></ng-icon> Delete
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>

          <!-- Support Avatar -->
          <img class="message-avatar793" *ngIf="item?.authorName === 'Gigsumo Support'"
            src='assets/icon/Sumoface_final.png'>

          <!-- User Avatar -->
          <img class="message-avatar793" *ngIf="item?.authorPhoto && item?.authorName != 'Gigsumo Support'"
            [src]="getPhotoUrl(item?.authorPhoto)">

          <!-- Author Initials -->
          <div *ngIf="item?.authorPhoto == undefined && item?.authorName != 'Gigsumo Support'">
            <div class="messageusername793 message-avatar793" [style.background-color]="getColor(item?.authorName)">
              <div class="circletext793" [style.color]="getFullNameTextColor(item?.authorName)">{{
                getInitials(item.authorName) }}</div>
            </div>
          </div>

          <!-- Online Status -->
          <!-- <span *ngIf="item?.online" class="logged-in793-1">●</span>
          <span *ngIf="!item?.online" class="logged-out793-1">●</span> -->

          <!-- Message Content -->
          <div class="message793">
            <a class="message-author793" [ngClass]="{'text-align-left793':  item['authorId'] !== userId}"
            [title]="item['authorName']" style="cursor: default;">
              {{item['authorName']}} </a>
            <!-- Rendered even when the message has no text but carries attachments:
                 the (empty) bubble forms the rounded top cap of the joined
                 text+media bubble, exactly like the message page does. -->
            <span class="message-content793" *ngIf="item['message'] || (item.attachments && item.attachments.length > 0)"
              [class.message-deleted793]="item['deleted'] || item['message'] === 'This message was deleted'"
              [innerHTML]="item['message']"></span>

            <!-- Media Attachments -->
            <div class="message-media793" *ngIf="item.attachments && item.attachments.length > 0">
              <ng-container *ngFor="let at of item.attachments; let a = index;">
                <!-- Images -->
                <div class="message-image793" *ngIf="at['attachmentType'] === 'image'"
                  (click)="showImageAndVideoPreview(item, a)">
                  <img [src]="url + at['url']" alt="Image attachment">
                </div>

                <!-- Videos -->
                <div class="message-video793" *ngIf="at['attachmentType'] === 'video'"
                  (click)="showImageAndVideoPreview(item, a)">
                  <video controls>
                    <source [src]="url + at['url']" [type]="at['mimetype']">
                    Your browser doesn't support this video format
                  </video>
                </div>

                <!-- Other Attachments -->
                <div class="message-attachment793"
                  *ngIf="at['attachmentType'] === 'application' || at['attachmentType'] === 'others'">
                  <ng-icon name="tablerFile" class="attachment-icon793"></ng-icon>
                  <div class="attachment-info793">
                    <div class="attachment-name793">{{at['name'] || 'Attachment'}}</div>
                    <div class="attachment-size793">{{at['size'] ? at['size'] : 'Unknown size'}}</div>
                  </div>
                </div>

                <!-- Audio -->
                <div class="message-attachment793" *ngIf="at['attachmentType'] === 'audio'">
                  <audio controls>
                    <source [src]="url + at['url']" [type]="at['mimetype']">
                    Your browser doesn't support this audio format
                  </audio>
                </div>
              </ng-container>
            </div>

            <span class="message-date793"  [ngClass]="{'text-align-left793':  item['authorId'] !== userId}"> {{item['sentDate'] | timezoneDate:'custom'}} </span>
          </div>
        </div>

        <!-- Action Message (not deactivated) -->
        <div class="chat-message793 center793"
          *ngIf="item.eventType=='ACTION'&& item?.actionType!='DEACTIVATED' && item.lowercaseMessage!='job  has been activated ' && item.lowercaseMessage!='candidate  has been activated '"
          [id]="item['messageId']">
          <span class="message-content793"
            style="text-align: center; color: #908a7d; font-size: 11px; background: rgba(0,0,0,0.03);"
            [innerHTML]="item['message']"></span>
        </div>

        <!-- Deactivation Message -->
        <div class="chat-message793 center793"
          *ngIf="item.eventType=='ACTION'&& item?.actionType=='DEACTIVATED'||item.eventType=='ACTION' && item.lowercaseMessage=='job  has been activated '||item.eventType=='ACTION' && item.lowercaseMessage=='candidate  has been activated '"
          [id]="item['messageId']">
          <span class="message-content793"
            style="text-align: center; color: #908a7d; font-size: 11px; background: rgba(0,0,0,0.03);"
            [innerHTML]="item['message']"></span>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Contact List When Owner -->
  <div id="chatbox793 OWNER_3" *ngIf="messageDataPass.owner" class="messages793">
    <div id="friendslist793">
      <!-- Search Box -->
      <div class="search-box793">
        <input class="form-control pd-lt-35" type="text" [(ngModel)]="searchName" placeholder="Search contacts...">
        <ng-icon name="tablerSearch" class="pos-rel-30"></ng-icon>
      </div>

      <div id="friends">
        <!-- Loading Skeleton -->
        <app-common-skeleton *ngIf="loaderstartstop && selectedUser?.groupType!='SUPPORT'&&contactList.length==0"
          [NameOftheScreen]="'userChat'"></app-common-skeleton>

        <!-- No Data Message -->
        <div class="gs-empty" *ngIf="contactList.length==0 && !loaderstartstop">
          <span class="gs-empty-icon"><ng-icon name="tablerMessage"></ng-icon></span>
          <div class="gs-empty-title">{{ nodatafound || 'No conversations' }}</div>
        </div>

        <!-- Contact List -->
        <ng-container *ngFor="let item of contactList | filter: searchName | sortByDate: 'lastMessageOn'">
          <div class="friend793" (click)="specfiuser(item)">
            <!-- Contact Image -->
            <img class="message-avatar793" *ngIf="item.groupType!='SUPPORT'&&item.groupLogo"
              [src]="getPhotoUrl(item?.groupLogo)">

            <!-- Contact Initials -->
            <div *ngIf="!item.groupLogo&&item.groupType!='SUPPORT'">
              <div class="messageusername793 message-avatar793" [style.background-color]="getColor(item?.groupName)">
                <div class="circletext793" [style.color]="getFullNameTextColor(item?.groupName)">{{
                  getInitials(item.groupName) }}</div>
              </div>
            </div>

            <!-- Support Image -->
            <img class="message-avatar793" *ngIf="item.groupType=='SUPPORT'"
              onerror="src='assets/icon/Sumoface_final.png'"
              [src]="item?.groupLogo ? getPhotoUrl(item?.groupLogo) : 'assets/icon/Sumoface_final.png'"
              [alt]="item?.groupLogo ? getPhotoUrl(item?.groupLogo) : 'assets/icon/Sumoface_final.png'">

            <!-- Online Status -->
            <span *ngIf="item?.online" class="logged-in793-1">●</span>
            <span *ngIf="!item?.online" class="logged-out793-1">●</span>

            <!-- Contact Information -->
            <div class="contact-info793">
              <!-- First Row: Name and Unread Count -->
              <div class="contact-row793">
                <div class="contact-name793" title="{{item?.groupName}}">
                  {{ item['groupName'] }}
                </div>

                <div class="status793" title="{{item?.nonSeenCount}}" *ngIf="item['nonSeenCount'] > 0">
                  {{ item['nonSeenCount'] }}
                </div>
              </div>

              <!-- Second Row: Entity ID and Time -->
              <div class="contact-row793">
                <span class="contact-entity793" title="{{item?.entityId}}" *ngIf="item?.entityId">
                  {{ item['entityId'] }}
                </span>

                <span class="contact-time793">
                  {{ item['lastMessageOn'] | messageTimestamp }}
                </span>
              </div>
            </div>
          </div>
          
        </ng-container>
      </div>
    </div>
  </div>
  <div class="inactive-user-warning793" *ngIf="messageDataPass.status == 'INACTIVE'">
    <div class="warning-icon793">
      <ng-icon name="tablerAlertCircle"></ng-icon>
    </div>
    <div class="warning-message793">
      You are no longer connected with this user and hence you cannot chat
    </div>
  </div>

  <div class="inactive-user-warning793"
    *ngIf="messageDataPass.groupType=='JOB' && messageDataPass.entitystatus == 'ON HOLD'">
    <div class="warning-icon793">
      <ng-icon name="tablerAlertCircle"></ng-icon>
    </div>
    <div class="warning-message793">
      Job is On Hold.
    </div>
  </div>

  <div class="inactive-user-warning793"
    *ngIf="messageDataPass.groupType=='JOB' && messageDataPass.entitystatus == 'FILLED'">
    <div class="warning-icon793">
      <ng-icon name="tablerAlertCircle"></ng-icon>
    </div>
    <div class="warning-message793">
      Job is Filled.
    </div>
  </div>

  <div class="inactive-user-warning793"
    *ngIf="(messageDataPass.status == 'DEACTIVATED' || messageDataPass.status == 'GROUP_INACTIVE') && messageDataPass.groupType=='CANDIDATE'">
    <div class="warning-icon793">
      <ng-icon name="tablerAlertCircle"></ng-icon>
    </div>
    <div class="warning-message793">
      Candidate is Unavailable.
    </div>
  </div>
  <!-- Message Input Form -->
  <form #myForm="ngForm">
    <div
      *ngIf="!messageDataPass.owner && messageDataPass.status != 'INACTIVE' && messageDataPass.status != 'DEACTIVATED' && messageDataPass.status != 'GROUP_INACTIVE'"
      class="message-box793">
      <!-- Message Input -->
      <div class="message-input793" #autofocusSendmsg [(ngModel)]="sendMessageData['message']" name="message"
        [ngxSummernote]="config" summernoteValidator #message="ngModel" required></div>

      <!-- Send Button (embedded: labelled pill per the wireframe) -->
      <button id="sendmsg" class="message-submit793" *ngIf="!editMessage"
        [disabled]="disableSendmsg || message.errors?.summernoteEmpty || isMessageBlank"
        (click)="sendmessage()">
        <ng-icon name="tablerSend"></ng-icon>
        <span class="send-label793" *ngIf="embedded">Send</span>
      </button>

      <!-- Update Button (when editing) -->
      <button id="sendmsg" class="message-submit793" *ngIf="editMessage"
        [disabled]="disableSendmsg || message.errors?.summernoteEmpty || isMessageBlank"
        (click)="updateMsg()">
        <ng-icon name="tablerSend"></ng-icon>
        <span class="send-label793" *ngIf="embedded">Update</span>
      </button>
    </div>
  </form>



  <!-- Status Messages -->
  <!-- <p class="text-center" style="margin-top: 35px; font-weight: 500; color: #666;" 
    *ngIf="messageDataPass.status == 'INACTIVE'">
    You are no longer connected with this user and hence you cannot chat
  </p>

  <p class="text-center" style="margin-top: 35px; font-weight: 500; color: #666;"
    *ngIf="messageDataPass.groupType=='JOB' && messageDataPass.entitystatus == 'ON HOLD'">
    Job is On Hold.
  </p>

  <p class="text-center" style="margin-top: 35px; font-weight: 500; color: #666;"
    *ngIf="messageDataPass.groupType=='JOB' && messageDataPass.entitystatus == 'FILLED'">
    Job is Filled.
  </p>

  <p class="text-center" style="margin-top: 35px; font-weight: 500; color: #666;"
    *ngIf="(messageDataPass.status == 'DEACTIVATED' || messageDataPass.status == 'GROUP_INACTIVE') && messageDataPass.groupType=='CANDIDATE'">
    Candidate is Unavailable.
  </p> -->

</div>

<!-- Image / Video Lightbox Preview — rendered OUTSIDE .containerChat793 so it is
     not trapped inside that fixed z-index:31 stacking context (which the app nav
     bar overlaps). At root level it sits above the nav, like the message page. -->
<div class="fancybox793">
    <div id="myModalWidget" class="modall793">
      <div
        style="display: flex; position: fixed; left: 0px; right: 0px; top: 0px; bottom: 0px; justify-content: center; align-items: center; flex-direction: column; flex: 1 1 auto; align-self: stretch; overflow: hidden; z-index: 10000;">
        <div role="none"
          style="position: relative; display: flex; flex-direction: column; flex-grow: 1; flex-shrink: 1; overflow: visible; align-items: stretch; align-self: stretch;">
          <div role="none"
            style="position: relative; display: flex; flex-direction: column; flex-grow: 1; flex-shrink: 1; overflow: visible; align-items: center; align-self: stretch; justify-content: flex-start;">
            <!-- Close -->
            <button class="close-button793" (click)="closeFancyModal()" title="Close" aria-label="Close"
              style="position: fixed; top: 85px; right: 24px; z-index: 100000;">×</button>
            <div role="none"
              style="position: absolute; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: hidden; align-items: center; left: 0px; right: 0px; top: 0px; bottom: 0px; background-color: rgb(0, 0, 0); justify-content: center; opacity: 1;">
            </div>
            <div role="none"
              style="position: absolute; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: visible; align-items: stretch; left: 0px; right: 0px; top: 0px; bottom: 0px; transform: translateX(0px);">
              <div role="none" class="mySlidessWidget" *ngFor="let item of fancyList"
                style="position: absolute; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: visible; align-items: stretch; left: 0px; right: 0px; top: 0px; bottom: 0px;">
                <div role="none"
                  style="position: absolute; display: flex; flex-direction: column; overflow: visible; align-items: stretch; left: 0px; right: 0px; top: 0px; bottom: 0px;">
                  <div role="none"
                    style="position: relative; display: flex; flex-direction: column; flex-grow: 0; flex-shrink: 0; overflow: hidden; align-items: stretch; width: 100%; height: 100%;">
                    <div role="none"
                      style="position: relative; display: flex; flex-direction: column; flex-grow: 1; flex-shrink: 1; overflow: visible; align-items: stretch;">
                      <div
                        style="position: relative; display: flex; flex-direction: column; flex-grow: 1; flex-shrink: 1; overflow: visible; align-items: center; align-self: stretch; justify-content: center;">
                        <div
                          style="position: absolute; display: flex; flex-direction: column; overflow: visible; align-items: stretch; justify-content: center; top: 0px; bottom: 0px; left: 0px; right: 0px; background-color: rgba(0, 0, 0, 0);">
                          <ng-container *ngIf="item['attachmentType'] === 'image'">
                            <div
                              style="position: absolute; overflow: visible; background-color: transparent; left: 0px; right: 0px; top: 0px; bottom: 0px; align-items: stretch; background-position: center center; background-repeat: no-repeat; background-size: contain; border-style: none; display: flex;"
                              [style.background-image]="'url(' + (item['fullUrl'] || (url + item['url'])) + ')'">
                            </div>
                          </ng-container>
                          <ng-container *ngIf="item['attachmentType'] === 'video'">
                            <div
                              style="position: absolute; overflow: visible; background-color: transparent; left: 0px; right: 0px; top: 0px; bottom: 0px; align-items: center; justify-content: center; display: flex;">
                              <video controls (click)="toggleVideo()" #videoPlayer793
                                style="max-width: 100%; max-height: 100%;">
                                <source [src]="url + item['url']" [type]="item['mimetype']" />
                                Browser not supported
                              </video>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Previous -->
            <div role="none"
              style="position: absolute; display: flex; flex-direction: column; overflow: visible; align-items: stretch; left: 0px; top: 0px; bottom: 0px; justify-content: center; z-index: 10001;">
              <button role="button" (click)="plusSlides(-1)" title="Previous" aria-label="Previous"
                style="display: flex; align-items: center; justify-content: center; background-color: rgba(0, 0, 0, 0.65); border: none; padding: 35px 14px; cursor: pointer;">
                <ng-icon name="tablerChevronLeft" style="font-size: 44px; color: rgb(213, 217, 222);"></ng-icon>
              </button>
            </div>

            <!-- Next -->
            <div role="none"
              style="position: absolute; display: flex; flex-direction: column; overflow: visible; align-items: stretch; right: 0px; top: 0px; bottom: 0px; justify-content: center; z-index: 10001;">
              <button role="button" (click)="plusSlides(1)" title="Next" aria-label="Next"
                style="display: flex; align-items: center; justify-content: center; background-color: rgba(0, 0, 0, 0.65); border: none; padding: 35px 14px; cursor: pointer;">
                <ng-icon name="tablerChevronRight" style="font-size: 44px; color: rgb(213, 217, 222);"></ng-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>